import {Pipe, PipeTransform, SecurityContext} from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import * as _ from 'lodash';

@Pipe({
  name: 'cleanRichText'
})
export class CleanRichTextPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: any): SafeHtml {
    if (!value) return '';

    const htmlString = _.isString(value)?value:this.sanitizer.sanitize(SecurityContext.HTML, value) || '';
    const doc = new DOMParser().parseFromString(htmlString, 'text/html');
    const paragraphs = doc.querySelectorAll('p');

    paragraphs.forEach(p => {
      let visibleText = (p.textContent || '');
      visibleText = visibleText.replace(/\s+/g, '');
      visibleText = visibleText.replace(/\u00A0/g, '');
      const onlyBreaks =
        p.innerHTML
          .replace(/<br\s*\/?>/gi, '')
          .replace(/&nbsp;/gi, '')
          .replace(/\s+/g, '')
          .length === 0;

      if (visibleText.length === 0 && onlyBreaks) {
        p.remove();
      }
    });


    return this.sanitizer.bypassSecurityTrustHtml(doc.body.innerHTML);
  }
}
